import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { MilestoneCategoryStore, MilestoneCategoryState } from './milestone-category.store';

@Injectable({ providedIn: 'root' })
export class MilestoneCategoryQuery extends QueryEntity<MilestoneCategoryState> {
  constructor(protected store: MilestoneCategoryStore) {
    super(store);
  }
}
